<div class="row">
  <div class="col-sm-12 request-header">
    <div class="box">
      <app-request-barcode [barcodeImage]="barcodeImage"></app-request-barcode>
      <h3 *ngIf="request.requestNumber" class="request-number-title">{{request.requestNumber}}</h3>
    </div>
    <div class="pull-right">
      <app-request-action-toolbar [request]="request"
                                  [isWheatRequest]="isWheatRequest"
                                  (statusChanged)="refreshView($event)"
                                  (saved)="refreshView($event)">
      </app-request-action-toolbar>
    </div>
  </div>
</div>
  
<div class="col-sm-12">
  <app-review-request 
    [request]="request" 
    [ceLogistics]="ceLogistics"
    [requestComments]="requestComments"
    [isWheatRequest]="isWheatRequest"
    [seedRequestUrl]="settings.seedRequestUrl"
  >
  </app-review-request>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/review-request-page/review-request-page.component.html